import { Inline, Button, Spinner } from '@leroy-merlin-br/backyard-react-ui'

const LoadMore = ({ hasMoreContent, onClick, isLoading }) => {
  if (!hasMoreContent) {
    return null
  }

  return (
    <Inline justify="center">
      <Button
        isRounded
        variant="outline"
        onClick={onClick}
        isDisabled={isLoading}
      >
        {isLoading ? <Spinner /> : 'Ver mais'}
      </Button>
    </Inline>
  )
}

export default LoadMore
